module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/banner728x90-33a4ea9839c89d505789c94b5b250a59.png";